export default __webpack_public_path__ + "static/media/sprintGame.9c19355c.svg";